export default __webpack_public_path__ + "static/media/Original_200by200.943e7815.png";